export const marketCountryCode = (market) =>
  String(market?.country_code || '').trim().toUpperCase();

/** Select options for markets configured in admin. Value is the ISO country code. */
export const toMarketSelectOptions = (markets = []) =>
  (markets || [])
    .map((market) => {
      const code = marketCountryCode(market);
      if (!code) return null;
      const country = market.country || {};
      const name = market.display_name || country.name || code;
      const emoji = country.emoji ? `${country.emoji} ` : '';
      return {
        value: code,
        label: `${emoji}${name} (${code})`.trim(),
      };
    })
    .filter(Boolean);

export const isConfiguredMarket = (markets, code) => {
  const target = String(code || '').trim().toUpperCase();
  if (!target) return false;
  return (markets || []).some((market) => marketCountryCode(market) === target);
};
